module.exports = __webpack_public_path__ + "img/survey1.8104ea71.jpg";